var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('select',{ref:`selectFx`,staticClass:"cs-select cs-skin-slide font-montserrat",on:{"change":function($event){return _vm.handleInput($event)}}},[_vm._t("default"),_vm._l((_vm.options),function(option){return _c('option',{key:option.value,domProps:{"value":option.value}},[_vm._v(_vm._s(option.content))])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }